const data = {
  primary: '#ffc000',
  secondary: '#e8eef9',
  title: '#152f46',
  header: '#152f46',
  footer: '#152f46'
}

export default data
